import type { ProductCategory } from '@collinsonx/utils/generatedTypes/graphql';

export const useValuationService =
  process.env.NEXT_PUBLIC_VALUATION_SERVICE === 'ON';

// TODO(TS-XXX / cleanup sub-task of TS-106): remove `useValuationPricing`
// and its `NEXT_PUBLIC_VALUATION_PRICING` env gate once valuation-driven
// pricing is fully rolled out and the legacy `product.saleprice` path is
// no longer needed.
export const useValuationPricing =
  process.env.NEXT_PUBLIC_VALUATION_PRICING === 'ON';

// Valuation does not yet support Fast Track pricing, so Fast Track is
// gated by its own flag instead of `useValuationPricing`, allowing it to
// move to valuation-driven pricing independently of the Lounge rollout.
export const useFastTrackValuationPricing =
  process.env.NEXT_PUBLIC_FAST_TRACK_VALUATION_PRICING === 'ON';

export const shouldUseValuationPricing = (
  category?: ProductCategory
): boolean =>
  category === 'FAST_TRACK'
    ? useFastTrackValuationPricing
    : useValuationPricing;

export const useMaintenanceMode =
  process.env.NEXT_PUBLIC_MAINTENANCE_MODE === 'ON';

export const useFastTrack = process.env.NEXT_PUBLIC_ENABLE_FAST_TRACK === 'ON';

export const useLogsAndEvents =
  process.env.NEXT_PUBLIC_DATADOG_INFOLOGS_SWITCH === 'ON';

export const useFTWithOutlet =
  process.env.NEXT_PUBLIC_ENABLE_FAST_TRACK_WITH_OUTLET === 'ON';

export const useMultipleProductsForFastTrack =
  process.env.NEXT_PUBLIC_ENABLE_MULTIPLE_PRODUCTS_FOR_FAST_TRACK === 'ON';

export const useProductType = process.env.NEXT_PUBLIC_USE_PRODUCT_TYPE === 'ON';

export const useCatalogueProductIDForAvailability =
  process.env.NEXT_PUBLIC_USE_CATALOGUE_PRODUCT_ID_FOR_AVAILABILITY === 'ON';

export const useFTEntitlementMessage =
  process.env.NEXT_PUBLIC_ENABLE_FT_ENTITLEMENT_MESSAGE === 'ON';

export const usePerVisitLimit =
  process.env.NEXT_PUBLIC_PER_VISIT_LIMIT === 'ON';

export const sourceCodesWithStandardPermission: string[] = (
  process.env.NEXT_PUBLIC_SOURCE_CODES_WITH_STANDARD_PERMISSION || ''
)
  .split(',')
  .map((code) => code.trim())
  .filter(Boolean);

export const sourceCodesWithElevatedPermission: string[] = (
  process.env.NEXT_PUBLIC_SOURCE_CODES_WITH_ELEVATED_PERMISSION || ''
)
  .split(',')
  .map((code) => code.trim())
  .filter(Boolean);

export const ftEntitlementSourceCodes: string[] = (
  process.env.NEXT_PUBLIC_FT_ENTITLEMENT_SOURCE_CODES || ''
)
  .split(',')
  .map((code) => code.trim())
  .filter(Boolean);

export const isFastTrackEntitlementSourceCode = (
  sourceCode?: string
): boolean =>
  useFTEntitlementMessage &&
  !!sourceCode &&
  ftEntitlementSourceCodes.includes(sourceCode);

export const ftEntitlementLegacyCodes: string[] = (
  process.env.NEXT_PUBLIC_FT_ENTITLEMENT_LEGACY_CODES || ''
)
  .split(',')
  .map((code) => code.trim())
  .filter(Boolean);

export const isFastTrackEntitlementLegacyCode = (
  legacyCode?: string
): boolean =>
  useFTEntitlementMessage &&
  !!legacyCode &&
  ftEntitlementLegacyCodes.includes(legacyCode);

export const isFastTrackEntitledUser = ({
  loungeCode,
  sourceCode,
}: {
  loungeCode?: string;
  sourceCode?: string;
}): boolean =>
  isFastTrackEntitlementSourceCode(sourceCode) &&
  isFastTrackEntitlementLegacyCode(loungeCode);
